import { render, staticRenderFns } from "./MioPrimoComponente.vue?vue&type=template&id=6b4f6649&scoped=true&"
import script from "./MioPrimoComponente.vue?vue&type=script&lang=js&"
export * from "./MioPrimoComponente.vue?vue&type=script&lang=js&"
import style0 from "./MioPrimoComponente.vue?vue&type=style&index=0&id=6b4f6649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f6649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4f6649')) {
      api.createRecord('6b4f6649', component.options)
    } else {
      api.reload('6b4f6649', component.options)
    }
    module.hot.accept("./MioPrimoComponente.vue?vue&type=template&id=6b4f6649&scoped=true&", function () {
      api.rerender('6b4f6649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MioPrimoComponente.vue"
export default component.exports